import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import "primereact/resources/themes/lara-light-indigo/theme.css";     
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { BrowserRouter } from 'react-router-dom';
import 'mapbox-gl/dist/mapbox-gl.css';
import { ErrorBoundary } from 'react-error-boundary';

function MyFallbackComponent({ error, resetErrorBoundary }: any) {
  return (
    <div role="alert" className='notallowed__wrapper'>
      <div className='notallowed__wrapper-text'>
        <p>Algo ha ido mal:</p>
        <p><small>Algún dato ha sido encapsulado mal en la respuesta, y el FRONTEND es incapaz de renderizarlo.</small></p>
        <pre style={{color:'white'}}>{error.message}</pre>
        <button onClick={resetErrorBoundary}>Recargar Página</button>
      </div>
    </div>
  )
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter>
    <ErrorBoundary FallbackComponent={MyFallbackComponent}>
      <App />
    </ErrorBoundary>
  </BrowserRouter>
);

// Medición de rendimiento (opcional)
reportWebVitals();
